import React from 'react';
import secureSvg from '../../assets/icons/secure-icon.svg';

interface SecureIconProps {
  size?: number;
  className?: string;
}

const SecureIcon: React.FC<SecureIconProps> = ({ size = 48, className = '' }) => {
  return (
    <img 
      src={secureSvg} 
      alt="Secure Icon"
      width={size}
      height={size}
      className={className}
    />
  );
};

export default SecureIcon;
